import { useState } from "react";
import { PaymentMethod, useShoppingCart } from "../context/ShoppingCartContext";
import CheckoutMaksekeskusModal from "./CheckoutMaksekeskusModal";
import usePageLanguage from "../hooks/usePageLanguage";
import React from "react";
interface Props {
  paymentMethod: PaymentMethod;
  setShowParentModal?: (val: boolean) => void;
  onPaymentSelected?: () => void;
}

export default function CheckoutPaymentMethodButton({
  paymentMethod,
  setShowParentModal = () => {},
  onPaymentSelected,
}: Props) {
  const [showModal, setShowModal] = useState(false);
  const lang = usePageLanguage();
  const { setPaymentMethod } = useShoppingCart();

  const maksekeskusPaymentMethod = paymentMethod.maksekeskusPaymentMethodName
    ? paymentMethod.apiClient?.maksekeskusPaymentMethods?.find(
        (item) => item.name === paymentMethod.maksekeskusPaymentMethodName
      ) ?? null
    : null;

  const handlePaymentClick = () => {
    setShowParentModal(false);
    setPaymentMethod(paymentMethod);
    if (onPaymentSelected) {
      onPaymentSelected();
    }
  };

  if (paymentMethod.getMaksekeskusApiActive) {
    return (
      <>
        <button
          className="btn btn-primary-outline paymentMethodMaksekeskus shop-controlled-border-radius "
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setShowModal(true);
          }}
        >
          {paymentMethod.translations?.[lang]?.name}
          {maksekeskusPaymentMethod ? (
            <img
              src={maksekeskusPaymentMethod.logoUrl}
              style={{ float: "right", maxWidth: "65px" }}
              alt=""
            />
          ) : (
            ""
          )}
        </button>
        {showModal && (
          <CheckoutMaksekeskusModal
            setShowParentModal={setShowParentModal}
            paymentMethod={paymentMethod}
            show={showModal}
            setShow={setShowModal}
            onPaymentSelected={onPaymentSelected}
          />
        )}
      </>
    );
  }
  return (
    <button
      className="btn btn-primary-outline paymentMethodButton shop-controlled-border-radius"
      onClick={(e) => {
        e.preventDefault();
        handlePaymentClick();
      }}
    >
      {paymentMethod.image ? (
        <img src={paymentMethod.imageUrl} height="25px" alt="" />
      ) : (
        <span>{paymentMethod.translations?.[lang]?.name}</span>
      )}
    </button>
  );
}
